// extracted by mini-css-extract-plugin
export default {"container--One":"resend-verification-email_container--One__fPlqG","container--div__labelTwo":"resend-verification-email_container--div__labelTwo__tdmIj"};